<template>
  <div class="container course-create">
    <div class="header">
      <el-breadcrumb
        class="breadcrumb"
        separator="/"
      >
        <el-breadcrumb-item>内容管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/material/list' }">实体资料</el-breadcrumb-item>
        <el-breadcrumb-item>实体资料创建</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <div class="left-item">
            <span>新订单通知:</span>
            <el-select
              v-model="admin_ids"
              placeholder="请选择"
              style="width: 300px;margin-left:16px;"
              multiple
              filterable
            >
              <el-option
                v-for="item in $store.state.adminList"
                :key="item.id"
                :label="item.nickname"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="left-item">
            <span style="margin:16px;">产品经理:</span>
            <el-autocomplete
              class="inline-input"
              v-model="manager_admin_id"
              :fetch-suggestions="querySearch"
              placeholder="请输入内容"
              :trigger-on-focus="false"
              @select="handleSelect"
              clearable
              style="width: 300px;margin-left:16px;"
            ></el-autocomplete>
          </div>
        </div>
        <div class="right">
          <el-button
            plain
            @click="handleClose"
          >取消</el-button>
          <el-button
            type="primary"
            @click="handleSubmit"
          >保存</el-button>
        </div>
      </div>
    </div>
    <div class="main">
      <h3 class="title">商品详情设置</h3>
      <div class="content">
        <el-form
          :model="dataForm"
          :rules="rules"
          ref="dataForm"
          label-width="130px"
          class="dataForm"
        >
          <div class="form-header">
            <div class="form-header-inner">基础信息</div>
          </div>
          <el-form-item
            label="商品橱窗图："
            prop="pictures"
          >
            <ul class="picture-list">
              <li
                class="picture-item"
                v-for="(item, $index) in dataForm.pictures"
                :key="$index"
              >
                <el-image
                  style="width: 148px; height: 148px"
                  :src="item.picture_url"
                  fit="cover"
                >
                </el-image>
                <div class="picture-actions">
                  <span
                    class="picture-action-item"
                    @click="handlePicturSortChange($index, 'up')"
                    v-if="$index !== 0"
                  >
                    <i class="el-icon-back"></i>
                  </span>
                  <span
                    class="picture-action-item"
                    @click="handlePicturSortChange($index, 'down')"
                    v-if="$index !== dataForm.pictures.length - 1"
                  >
                    <i class="el-icon-right"></i>
                  </span>
                  <span
                    class="picture-action-item"
                    @click="handlePicturRemove($index)"
                  >
                    <i class="el-icon-delete"></i>
                  </span>
                </div>
              </li>
            </ul>
            <el-upload
              v-if="dataForm.pictures.length < 5"
              class="avatar-uploader"
              :action="imgUploadUrl"
              list-type="picture-card"
              :file-list="dataForm.pictures"
              :headers="uploadHeaders"
              :on-success="handleUploadSuccess"
              :before-upload="handleBeforeUpload"
              :show-file-list="false"
            >
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div class="el-upload__tip">
              最多可上传5张，支持扩展名：.jpg .png .jpge;
              图片大小为：105px*105px
            </div>
          </el-form-item>
          <el-form-item
            label="商品名称："
            prop="name"
          >
            <el-input
              v-model="dataForm.name"
              placeholder="输入商品名称"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="商品简介："
            prop="description"
          >
            <el-input
              v-model="dataForm.description"
              placeholder="输入商品简介"
              type="textarea"
              :rows="2"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="商品标签："
            prop="tags"
          >
            <el-input
              v-model="dataForm.tags"
              placeholder="输入商品标签，多个用英文逗号隔开"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="资料分类："
            prop="category_id"
          >
            <el-select
              v-model="dataForm.category_id"
              placeholder="选择分类"
              style="width: 300px"
            >
              <el-option
                v-for="item in categorys"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="适合科目："
            prop="subjects"
          >
            <div class="tag-wrap">
              <el-tag
                class="subject-item"
                size="medium"
                :key="item.id"
                v-for="item in subjects"
                closable
                :disable-transitions="false"
                @close="handleSubjectRemove(item)"
              >
                {{
                  item.college_name
                    ? `${item.college_name}-${item.name}`
                    : item.name
                }}
              </el-tag>
              <el-button
                type="text"
                @click="handleSubjectChoose"
              >选择科目</el-button>
            </div>
          </el-form-item>
          <el-form-item
            label="适合专业："
            prop="majors"
          >
            <div class="tag-wrap">
              <el-tag
                class="subject-item"
                size="medium"
                :key="item.id"
                v-for="item in majors"
                closable
                :disable-transitions="false"
                @close="handleMajorRemove(item)"
              >
                {{ `${item.name}/${item.code}` }}
              </el-tag>
              <el-button
                type="text"
                @click="handleMajorChoose"
              >选择专业</el-button>
            </div>
          </el-form-item>
          <el-form-item
            label="适合院校："
            prop="colleges"
          >
            <div class="tag-wrap">
              <el-tag
                class="subject-item"
                size="medium"
                :key="item.id"
                v-for="item in colleges"
                closable
                :disable-transitions="false"
                @close="handleCollegeRemove(item)"
              >
                {{ `${item.name}` }}
              </el-tag>
              <el-button
                type="text"
                @click="handleCollegeChoose"
              >选择院校</el-button>
            </div>
          </el-form-item>
          <div class="form-item-wrap">
            <el-form-item
              class="price"
              label="售价："
              prop="price"
            >
              <el-input
                v-model="dataForm.price"
                placeholder="输入售价"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="划线价："
              prop="market_price"
            >
              <el-input
                v-model="dataForm.market_price"
                placeholder="输入划线价"
              ></el-input>
            </el-form-item>
          </div>
          <el-form-item
            label="花呗分期："
            prop="year"
          >
            <el-select
              v-model="dataForm.hb_fq_num_level"
              placeholder="选择花呗分期"
              style="width: 300px"
            >
              <el-option
                label="含手续费"
                :value="0"
              >
              </el-option>
              <el-option
                label="三期免息"
                :value="3"
              >
              </el-option>
              <el-option
                label="六期免息"
                :value="6"
              >
              </el-option>
              <el-option
                label="十二期免息"
                :value="12"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <div class="form-item-wrap">
            <el-form-item
              label="基础购买数："
              prop="virtual_count"
            >
              <el-input
                v-model="dataForm.virtual_count"
                placeholder="输入在学基础数"
              ></el-input>
            </el-form-item>
          </div>
          <el-form-item
            label="销售截止日期："
            prop="expire_time"
          >
            <el-date-picker
              v-model="dataForm.expire_time"
              type="date"
              placeholder="选择日期"
              style="width: 300px"
            >
            </el-date-picker>
          </el-form-item>
          <!--     <el-form-item label="发布人：" prop="author_id">
            <el-select v-model="dataForm.author_id" filterable remote reserve-keyword :remote-method="fetchAuthorList" placeholder="搜索作者，选择保存" style="width: 300px">
              <el-option :label="`${item.realname}/${item.mobile}`" :value="item.id" v-for="item in authors" :key="item.id"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item
            label="服务描述："
            prop="service"
          >
            <el-input
              v-model="dataForm.service"
              placeholder="输入服务描述，如：付款后15天内发货，提供售后服务"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="关联用户分组"
            prop="user_category_ids"
          >
            <el-select
              v-model="dataForm.user_category_ids"
              placeholder="选择分类"
              style="width: 800px"
              multiple
            >
              <el-option
                v-for="item in userCategorys"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建人">
            <el-select
              v-model="dataForm.creator"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in $store.state.adminList"
                :key="item.id"
                :label="item.nickname"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
           <el-form-item
            label="协议编码"
            prop="product_agreement_codes"
          >
            <el-select
              v-model="dataForm.product_agreement_codes"
              placeholder="选择协议编码"
              multiple
              style="width: 300px"
            >
              <el-option
                v-for="item in $store.state.agreementList||[]"
                :key="item.id"
                :label="item.name"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="排序值">
            <el-input
              v-model="dataForm.sort"
              placeholder="输入排序值"
              style="width:300px;"
              oninput="value=value.replace(/[^0-9.]/g,'')"
            ></el-input>
          </el-form-item>
          <div class="form-item-wrap">
            <el-form-item
              label="上架状态："
              prop="status"
            >
              <el-switch v-model="dataForm.status"></el-switch>
            </el-form-item>
            <el-form-item
              label="配送服务："
              prop="is_deliver"
            >
              <el-switch v-model="dataForm.is_deliver"></el-switch>
            </el-form-item>
          </div>
          <Teacher
            :content="{ teachers: teachers }"
            @save="saveTeacher"
          />
          <div class="form-header">
            <div class="form-header-inner">规格属性</div>
          </div>
          <Property
            :productId="dataForm.id"
            :content="{ skus: skus, properties: properties }"
            @save="saveSkus"
          />
          <div class="form-header">
            <div class="form-header-inner">详情描述</div>
          </div>
          <el-form-item
            class="course-detail"
            label="商品详情："
            prop="detail"
          >
            <UEeditor
              :setDataStr="dataForm.detail"
              @change="initDtaForm"
            />
          </el-form-item>
        </el-form>
      </div>
    </div>
    <SubjectChoose
      :visible="subjectChooseDialog"
      :subjects="subjects"
      @close="subjectChooseDialog = false"
      @submit="saveSubject"
    ></SubjectChoose>
    <MajorChoose
      :visible="majorChooseDialog"
      :majors="majors"
      @close="majorChooseDialog = false"
      @submit="saveMajor"
    ></MajorChoose>
    <CollegeChoose
      :visible="collegeChooseDialog"
      :colleges="colleges"
      @close="collegeChooseDialog = false"
      @submit="saveCollege"
    ></CollegeChoose>
  </div>
</template>

<script>
import Property from "../product/property";
import Teacher from "../product/teacher";
import SubjectChoose from "@/components/dialog/subject/SubjectChoose";
import MajorChoose from "@/components/dialog/major/MajorChoose";
import CollegeChoose from "@/components/dialog/college/CollegeChoose";
import { imgUploadUrl, uploadHeaders } from "@/config/index";
import { materialCreate, materialcategorylist } from "@/api/material";
import { seniorList } from "@/api/senior";
import { memberCategoryList } from "@/api/member";
import UEeditor from "@/components/UEeditor";
import { getStorage } from "@/utils/helper";


export default {
  components: {
    Teacher,
    Property,
    SubjectChoose,
    MajorChoose,
    CollegeChoose,
    UEeditor
  },
  data() {
    return {
      subjectChooseDialog: false,
      majorChooseDialog: false,
      collegeChooseDialog: false,
      imgUploadUrl: imgUploadUrl(),
      uploadHeaders: uploadHeaders(),

      dataForm: {
        vip_discount_rate: 1,
        express_cost: 0,
        pictures: [],
        status: true,
        is_deliver: true,
      },
      subjects: [],
      majors: [],
      colleges: [],
      teachers: [],
      authors: [],
      skus: [],
      properties: [],
      categorys: [],// 分类列表
      userCategorys: [],
      rules: {
        name: [
          { required: true, message: "请输入商品名称", trigger: "blur" },
          {
            min: 3,
            max: 35,
            message: "长度在 3 到 35 个字符",
            trigger: "blur",
          },
        ],
        description: [
          { required: true, message: "请输入课程简介", trigger: "blur" },
        ],
        market_price: [
          { required: true, message: "请输入划线价", trigger: "blur" },
          { pattern: /^(\d+|\d+\.\d{1,2})$/, message: '输入最多两位小数的数字' }
        ],
        price: [{ required: true, message: "请输入售价", trigger: "blur" },
        { pattern: /^(\d+|\d+\.\d{1,2})$/, message: '输入最多两位小数的数字' }],
        vip_discount_rate: [
          { required: true, message: "请选择会员优惠", trigger: "blur" },
        ],
        pictures: [
          {
            required: true,
            message: "请上传商品橱窗图",
            trigger: "change",
            validator: (rule, value, callback) => {
              if (!this.dataForm.pictures.length) {
                return callback(new Error(rule.message));
              } else {
                callback();
              }
            },
          },
        ],
        // subjects: [
        //   { required: true, message: '请选择适合科目', trigger: 'change', validator: (rule, value, callback) => {
        //     if (!this.subjects.length) {
        //       return callback(new Error(rule.message))
        //     } else {
        //       callback()
        //     }
        //   }}
        // ],
        author_id: [
          { required: false, message: "请选择作者/学长", trigger: "blur" },
        ],
        expire_time: [
          { required: true, message: "请选择商品结束日期", trigger: "blur" },
        ],
        virtual_count: [
          { required: true, message: "请输入基础购买数", trigger: "blur" },
          { pattern: /^(\d+|\d)$/, message: '只能输入数字' }
        ],
        express_cost: [
          { required: true, message: "请输入快递费用", trigger: "blur" },
        ],
        service: [
          { required: true, message: "请输入服务描述", trigger: "blur" },
        ],
        detail: [
          { required: true, message: "请输入商品详情描述", trigger: "blur" },
        ],
        user_category_ids: [
          { required: true, message: "请选择关联用户分类", trigger: "blur" },
        ],
      },
      admin_ids: "",
      manager_admin_id: "",
    };
  },
  mounted() {
    this.scrollToTop();
    this.fetchCategoryList();
    this.fetchUserCategoryList()
    this.$store.dispatch('getAdminList')
    this.$store.dispatch('fetchAgreementList')
    this.manager_admin_id = getStorage('admin_user').nickname
    this.dataForm.manager_admin_id = getStorage('admin_user').id
  },
  methods: {
    fetchAuthorList(name) {
      seniorList({ keyword: name, isPaging: 0 }).then((res) => {
        this.authors = res.list;
      });
    },
    // 资料分类列表请求
    fetchCategoryList() {
      materialcategorylist({ status: 1, isPaging: 0 }).then((res) => {
        let list = res.list || [];
        list.unshift({ id: null, name: "全部" });
        this.categorys = list;
      });
    },
    // 获取用户分类列表
    fetchUserCategoryList() {
      memberCategoryList({ status: 1, isPaging: 0 }).then((res) => {
        this.userCategorys = res.list || [];
      });
    },
    scrollToTop() {
      // Chrome
      document.body.scrollTop = 0;
      // Firefox
      document.documentElement.scrollTop = 0;
      // Safari
      window.pageYOffset = 0;
    },
    // 图文详情
    handleDetailChange(editor) {
      this.dataForm.detail = editor.html;
    },
    // 科目删除
    handleSubjectRemove(item) {
      this.subjects = this.subjects.filter((v) => v.id !== item.id);
    },
    // 科目选择
    handleSubjectChoose() {
      this.subjectChooseDialog = true;
    },
    // 科目保存
    saveSubject({ subjects }) {
      this.subjects = subjects;
    },
    handleMajorRemove(item) {
      this.majors = this.majors.filter((v) => v.id !== item.id);
    },
    handleMajorChoose() {
      this.majorChooseDialog = true;
    },
    saveMajor({ majors }) {
      this.majors = majors;
    },
    handleCollegeRemove(item) {
      this.colleges = this.colleges.filter((v) => v.id !== item.id);
    },
    handleCollegeChoose() {
      this.collegeChooseDialog = true;
    },
    saveCollege({ colleges }) {
      this.colleges = colleges;
    },
    saveTeacher({ teachers }) {
      this.teachers = teachers;
    },
    saveSkus(val) {
      if (val.skus) {
        this.skus = val.skus;
      }
      if (val.properties) {
        this.properties = val.properties;
      }
      if (!this.properties.length) {
        this.skus = [];
      }
    },
    // 图片上传成功
    handleUploadSuccess(res, file) {
      if (res.code == 0 && res.data) {
        this.dataForm.pictures.push({ name: "", picture_url: res.data.url });
      } else {
        this.$message.error(res.error);
      }
    },
    // 图片上传前处理
    handleBeforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 5;

      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 5MB!");
      }
      return isLt2M;
    },
    // 图片排序变化
    handlePicturSortChange(index, type) {
      let item = this.dataForm.pictures.splice(index, 1)[0];
      if (type == "up") {
        this.dataForm.pictures.splice(index - 1, 0, item);
      } else if (type == "down") {
        this.dataForm.pictures.splice(index + 1, 0, item);
      }
    },
    // 图片删除
    handlePicturRemove(index) {
      this.dataForm.pictures.splice(index, 1);
    },
    handleSubmit() {
      if (this.skus.findIndex((v) => { return v.price == "" || v.stock == "" }) >= 0) {
        this.$message.error("请填写所有必填信息");
        return
      }
      if (this.skus.findIndex((v) => { return !(/^(\d+|\d+\.\d{1,2})$/).test(v.price) || !(/^(\d+|\d)$/).test(v.stock) }) >= 0) {
        this.$message.error("价格或库存输入不正确");
        return
      }
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          let params = Object.assign({}, this.dataForm, {
            subjects: this.subjects.map((item) => ({
              code: item.code,
              college_code: item.college_code,
            })),
            majors: this.majors.map((item) => ({
              code: item.code,
              college_code: item.college_code,
            })),
            colleges: this.colleges.map((item) => ({ code: item.code })),
            teachers: this.teachers.map((item) => ({
              id: item.id,
              type: item.type,
              sort: item.sort,
            })),
            skus: this.skus,
            user_category_ids: this.dataForm.user_category_ids.join(','),
            admin_ids: this.admin_ids.join(','),
            hb_fq_num_level: this.dataForm.hb_fq_num_level,
            creator: this.dataForm.creator,
            product_agreement_codes:this.dataForm.product_agreement_codes.join(',')
          });
          params.status = params.status ? 1 : 0;
          params.is_deliver = params.is_deliver ? 1 : 0;
          params.picture_url = params.pictures[0].picture_url;
          params.market_price = Number(params.market_price);
          params.price = Number(params.price);
          params.expire_time = this.$moment(params.expire_time).valueOf();
          materialCreate(params)
            .then((res) => {
              this.$message.success(`创建成功`);
              this.$refs["dataForm"].resetFields();

              this.$router.go(-1);
            })
            .catch((error) => {
              console.log("error: ", error);
            });
        } else {
          this.$message.error("请填写所有必填信息");
          return false;
        }
      });
    },
    handleClose() {
      this.$router.go(-1);
    },
    initDtaForm(e) {
      this.dataForm.detail = e
    },
    querySearch(queryString, cb) {
      var restaurants = this.$store.state.adminList.map((v) => {
        return {
          value: v.nickname,
          id: v.id
        }
      });
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    handleSelect(item) {
      this.dataForm.manager_admin_id = item.id
    },
  },
};
</script>

<style scoped lang="less">
.course-create {
  .header {
    background: #fff;
    padding: 20px;

    .breadcrumb {
      margin-bottom: 20px;
    }
    .content {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
  .main {
    background: #fff;
    padding: 20px;
    margin-top: 10px;

    .title {
      font-size: 32px;
      font-weight: bold;
    }
  }
  .content {
    display: flex;
    margin-top: 20px;

    .left {
      display: flex;
      align-items: center;
    }
    .left-item {
    }

    .datForm {
      min-width: 700px;
      width: 100%;
    }

    .button {
      font-size: 14px;
      padding: 12px 20px;
      margin-bottom: 10px;

      &.small {
        padding: 9px 15px;
      }
    }
    .picture-list {
      display: inline-block;
      line-height: 1;
      vertical-align: top;
    }
    .picture-item {
      position: relative;
      overflow: hidden;
      background-color: #fff;
      border: 1px solid #c0ccda;
      border-radius: 6px;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      width: 148px;
      height: 148px;
      margin-right: 8px;
      display: inline-block;
    }
    .picture-actions {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      cursor: default;
      color: #fff;
      opacity: 0;
      font-size: 20px;
      background-color: rgba(0, 0, 0, 0.5);
      transition: opacity 0.3s;

      display: flex;
      align-items: center;
      justify-content: center;

      &:hover {
        opacity: 1;
      }

      .picture-action-item {
        cursor: pointer;

        & + .picture-action-item {
          margin-left: 15px;
        }
      }
    }
    .avatar-uploader {
      display: inline-block;
    }
    .avatar-uploader /deep/ .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader /deep/ .el-upload:hover {
      border-color: #409eff;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 148px;
      height: 148px;
      line-height: 148px;
      text-align: center;
    }
    .avatar {
      display: block;
      width: 148px;
      height: 148px;
      object-fit: cover;
    }
    .el-upload__tip {
      line-height: 20px;
    }
    .form-item-wrap {
      display: flex;

      /deep/ .el-input {
        width: 300px;
      }
    }
    .course-detail {
      /deep/ .el-form-item__content {
        line-height: 1;
      }
    }
    .tag-wrap {
      display: flex;
      flex-wrap: wrap;
    }
    .subject-item {
      margin-right: 5px;
      margin-bottom: 5px;
    }
  }

  .form-header {
    font-size: 14px;
    font-weight: bold;
    color: #333;
    background: #f8f8f8;
    margin-bottom: 20px;

    .form-header-inner {
      padding: 10px;
    }
  }
}
</style>
